import Joi from "joi";

export const JoiCuisineScheme = Joi.object({
  id: Joi.number().required(),
  name: Joi.string().required().allow(""),
  sort: Joi.number().optional(),
  status: Joi.boolean().optional(),
});
